import { render, staticRenderFns } from "./NestedDatasetDisplay.vue?vue&type=template&id=2514a3b0&scoped=true&"
import script from "./NestedDatasetDisplay.vue?vue&type=script&lang=js&"
export * from "./NestedDatasetDisplay.vue?vue&type=script&lang=js&"
import style0 from "./NestedDatasetDisplay.vue?vue&type=style&index=0&id=2514a3b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2514a3b0",
  null
  
)

export default component.exports